module.exports = "https://static.im-cdn.com/mjc/storefront/Simplar/static/media/bannerSlider.dd624d40.svg";